const usePaymentTerms = () => {
  // Define Table Columns
  const columns = [
    {
      accessorKey: "percent",
      header: "Percentage",
      accessorFn: (row: any) =>
        String(row?.percent || ""),
    },
    {
      accessorKey: "days",
      header: "Days",
      accessorFn: (row: any) =>
        String(row?.days || ""),
    },
    {
      accessorKey: "description",
      header: "Payment Term Text",
      accessorFn: (row: any) => String(row?.description || ""),
    }
  ];

  return {
    columns
  };
};

export default usePaymentTerms;
